import React from 'react';
import { Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = theme => ({
    proLabel: {
        opacity: 0.8,
        position: 'absolute',
        textAlign: 'start',
        paddingTop: 5,
        paddingLeft: 10,
        fontWeight: 'bold'
    }
});

const ResolutionMediaCardLabel = (props) => {
    const { classes, width, resolution } = props;
    
    return (
        <Typography 
            className={classes.proLabel}
            style={{width: width}}
        >
            {resolution}
        </Typography>
    );
};

export default withStyles(ResolutionMediaCardLabel, styles);